class InsiderTracking {
  constructor() {
    this.knownBrands = {
      'Koala': 'Koala',
      'Supercoffee': 'SuperCoffee',
      'SuperCoffee': 'SuperCoffee',
      'Morning Shot': 'Morning Shot',
      'Whey': 'Labs',
      'Cratina': 'Labs',
      'Pack': 'Pack',
    };
    this.knownCategories = {
      '380g': 'Economic',
      '456g': 'Economic',
      '220g': 'Classic',
      '264g': 'Classic',
      'Morning Shot': 'Classic',
      'Whey': 'Labs',
      'Cratina': 'Labs',
      'Pack': 'Pack',
    }
  }

  async trackEvent(eventName, eventParams) {
    window.Insider.track('events', [{
      "event_name": eventName,
      "timestamp": String(Math.floor(Date.now() / 1000)),
      "event_params": eventParams
    }]);
  }

  trackPageView(pageName) {
    const path = window.location.pathname;
    if (pageName) {
      this.trackEvent('page_view', {
        'page_name': pageName,
        'url': window.location.href,
      });
    } else {
      this.trackEvent('page_view', {
        'page_name': path === '/' ? 'Home Page' : path.replace(/\//g, '-').substring(1),
        'url': window.location.href,
      });
    }
  }

  findProductBrand(productTitle) {
    const titleLower = productTitle.toLowerCase();

    for (const brand in this.knownBrands) {
      if (titleLower.includes(brand.toLowerCase())) {
        return this.knownBrands[brand];
      }
    }
    return 'unknown';
  }

  findProductFlavor(productTitle) {
    if (productTitle.toLowerCase().includes('pack')) return 'Pack';
    const brandsRegex = new RegExp(Object.keys(this.knownBrands).join('|') + '|380g|456g|220g', 'gi');
    const flavorMatch = productTitle.replace(brandsRegex, '').replace(/\s+/g, ' ').trim();
    return flavorMatch || 'unknown';
  }

  findProductCategory(productTitle) {
    const titleLower = productTitle.toLowerCase();

    for (const category in this.knownCategories) {
      if (titleLower.includes(category.toLowerCase())) {
        return this.knownCategories[category];
      }
    }
    return 'unknown';
  }
  handleStorefrontFilter(eventAction, filterName, sectionName) {
    if (eventAction === 'add') {
      this.trackEvent('ecom_storefront_filter_applied', {
        filter_value: filterName,
        section_name: sectionName
      });
    } else {
      this.trackEvent('ecom_storefront_filter_removed', {
        filter_value: filterName,
        section_name: sectionName
      });
    }
  }
  calculateDistanceFromTop(element) {
    const rect = element.getBoundingClientRect();
    return Number((rect.top + window.scrollY).toFixed(0));
  }

  handleCartAddUpsellProduct(variantId, price) {
    loadAndUpdateCart(variantId);
    this.trackEvent("ecom_add_to_cart", {
      "pid": variantId,
      "p_price": price,
    });
  }

  handleCartContinueShopping() {
    closeCartDrawer()
    this.trackEvent('ecom_cart_continue_shopping_click', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
    });
  }


  async handleCartBeginCheckout(cuponCode) {
    if (!cartObject) {
      window.location.href = '/checkout';
      return;
    }
    await this.trackEvent('cart_begin_checkout', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
      'c_has_free_gift': cartObject.items?.some(item => item.handle.includes('brinde')),
    }).then(() => {
      if (cuponCode) {
        handleCheckoutWithDiscount(cuponCode)
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  handleClearCart() {
    clearCart()
    this.trackEvent('ecom_cart_clear', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
      'c_has_free_gift': cartObject.items.some(item => item.handle.includes('brinde')),
    });
  }

  handleStorefrontBannerClick(id, blockSettings) {
    const banner = document.getElementById(`banner-${id}`);
    this.trackEvent('ecom_storefront_banner_click', {
      "c_position": this.calculateDistanceFromTop(banner),
      "c_file_name": blockSettings.image_desktop ? blockSettings.image_desktop : 'no_image',
      "c_link": blockSettings.link ? blockSettings.link : 'no_link',
    });
  }

  observeStorefrontProductCard(productCardSelector, productData, sectionId, productFlavor) {
    const productCard = document.getElementById(productCardSelector);

    if (!productCard) return;

    const productCardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.trackEvent('ecom_product_impression', {
            "pid": productData.variants[0].id,
            "c_product_name": productData.variants[0].name,
            "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
            "c_brand": this.findProductBrand(productData.title),
            "c_position": this.calculateDistanceFromTop(productCard),
            "c_category": this.findProductCategory(productData.title),
            "c_sabor": productFlavor ? productFlavor : this.findProductFlavor(productData.title),
            "c_list_name": sectionId,
          });
          productCardObserver.unobserve(productCard);
        }
      });
    });

    productCardObserver.observe(productCard);
  }
  async trackProductStorefrontClick(element, productData) {
    const { flavor, listName } = element.dataset;
    await this.trackEvent('ecom_product_storefront_product_click', {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
      "c_brand": this.findProductBrand(productData.title),
      "c_position": this.calculateDistanceFromTop(element),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": flavor ? flavor : this.findProductFlavor(productData.title),
      "c_list_name": listName,
    }).then(() => {
      if (this.findProductCategory(productData.title) !== 'Pack') {
        redirectTo(`/products/${productData.handle}`);
      }
    }
    )
  }

  async trackProductStorefrontAddToCartClick(element, productData) {
    const { flavor, listName } = element.dataset;
    this.trackEvent('ecom_product_storefront_product_cart_add', {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
      "c_brand": this.findProductBrand(productData.title),
      "c_position": this.calculateDistanceFromTop(element),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": flavor ? flavor : this.findProductFlavor(productData.title),
      "c_list_name": listName,
    })
  }
}
const insiderTracking = new InsiderTracking();